"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFetchEntitlement = void 0;
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const AuthGuard_1 = require("../../components/tsComponents/AuthGuard");
const entitlementAction_1 = require("./entitlementAction");
const useFetchEntitlement = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const fetchEntitlementLoading = (0, react_redux_1.useSelector)((state) => state['entitlement/fetch'].loading);
    const fetchEntitlementError = (0, react_redux_1.useSelector)((state) => state['entitlement/fetch'].error);
    const fetchEntitlementData = (0, react_redux_1.useSelector)((state) => state['entitlement/fetch'].data);
    const fetchEntitlement = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            let userLogged = yield (0, AuthGuard_1.isLoggedIn)();
            if (!userLogged) {
                history('/auth/sign-in');
                return;
            }
            yield dispatch((0, entitlementAction_1.fetch)());
        }
        catch (error) {
            history('/auth/sign-in');
        }
    });
    return {
        fetchEntitlementLoading,
        fetchEntitlementError,
        fetchEntitlementData,
        fetchEntitlement
    };
};
exports.useFetchEntitlement = useFetchEntitlement;
